<app-navigation [branding]="branding"></app-navigation>
<div class="main {{branding}}">
    <router-outlet></router-outlet>
</div>
<app-footer [branding]="branding"></app-footer>
